/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import AppNavbarMenu from './menu';
import { menuLinks } from './data/menu-links';
import AppNavbarSearchInput from './search-input';
import { routes } from '@/infrastructure/const/routes';
import AppNavbarExpansionPanel from './expansion-panel';
import { DevicesWidth } from '@/infrastructure/enum/device-width';
import { useNavbar } from '@/infrastructure/context/navbar-context';
import s from './styles.module.scss';

const AppNavbarComponent: React.FC = (props) => {
  const { opened } = useNavbar();

  const { t: tLinks } = useTranslation('links');
  const links = menuLinks(tLinks);

  const navbarClassNames = classNames(s['navbar'], {
    [s['opened']]: opened,
  });

  return (
    <div className={navbarClassNames}>
      <Link
        href={routes.home}
        prefetch={false}
        passHref
        className={s['logo']}
        aria-label="home link"
      />
      <AppNavbarSearchInput className={s['search']} />
      <AppNavbarMenu className={s['menu']} links={links} />
      <AppNavbarExpansionPanel />
    </div>
  );
};

const AppNavbar: React.FC = () => {
  const { opened, close } = useNavbar();

  const router = useRouter();

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > DevicesWidth.MD) {
        close();
      }
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  useEffect(() => {
    if (router) close();
  }, [router]);

  useEffect(() => {
    if (opened) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'unset';
    }
  }, [opened]);

  return (
    <>
      <div
        className={classNames(s['backdrop'], {
          [s['opened']]: opened,
        })}
        onClick={(e) => {
          e.preventDefault();
          close();
        }}
      />
      <AppNavbarComponent />
    </>
  );
};

export default AppNavbar;
